export default __webpack_public_path__ + "static/media/no.c1784c5e.svg";